module.exports = __webpack_public_path__ + "img/bread-640.6e131ee5.jpg";